import React from "react";
import { Button, Image, Row, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { IDocument } from "../../../customTypings/document/Document";
import { IFolder } from "../../../customTypings/document/Folder";

interface DocumentTileViewProps {
  folders: IFolder[];
  documents: IDocument[];
  removeActionActive: boolean;
  onFolderClick: (folder: IFolder) => void;
  onDocumentClick: (document: IDocument) => void;
  onRemoveFolder: (folder: IFolder) => void;
  onRemoveDocument: (document: IDocument) => void;
  onAddFile: () => void;
  onToggleRemove: () => void;
}

export const DocumentTileView: React.FC<DocumentTileViewProps> = ({
  folders,
  documents,
  removeActionActive,
  onFolderClick,
  onDocumentClick,
  onRemoveFolder,
  onRemoveDocument,
  onAddFile,
  onToggleRemove,
}) => {
  const tileIconStyle = { width: "100%", height: "7rem" };
  const tileButtonStyle = { width: "8rem" };
  const addButtonStyle = { width: "8rem", height: "8rem" };

  return (
    <Row>
      {folders &&
        folders.map((folder) => (
          <div
            className="w-auto d-inline-block pe-0 mb-2"
            key={folder.id}
          >
            <Button
              variant={
                removeActionActive ? "outline-danger" : "outline-primary"
              }
              style={tileButtonStyle}
              className="border-0 lh-1"
              onClick={() =>
                removeActionActive
                  ? onRemoveFolder(folder)
                  : onFolderClick(folder)
              }
            >
              {removeActionActive && <FontAwesomeIcon icon={faTrash} />}
              <Image
                src={`/api/thumbnail/a43ab016-c96c-4911-86cd-b3a9687d89c2`}
                style={tileIconStyle}
                className="w-100 image-contain mb-2"
              />
              <span className="text-center w-100">{folder.name}</span>
            </Button>
          </div>
        ))}
      {documents &&
        documents.map((document) => (
          <div
            className="w-auto d-inline-block pe-0 mb-2"
            key={document.id}
          >
            <Button
              variant={
                removeActionActive ? "outline-danger" : "outline-primary"
              }
              style={tileButtonStyle}
              className="border-0 lh-1"
              onClick={() =>
                removeActionActive
                  ? onRemoveDocument(document)
                  : onDocumentClick(document)
              }
            >
              {removeActionActive && <FontAwesomeIcon icon={faTrash} />}
              <Image
                src={`/api/thumbnail/${document.documentThumbnailId}`}
                style={tileIconStyle}
                className="w-100 image-contain mb-2"
              />
              <span className="text-center w-100">
                {document.fileName}
              </span>
            </Button>
          </div>
        ))}
      <div className="w-auto d-inline-block mb-2">
        <Stack direction="vertical">
          <Button
            variant="outline-primary"
            style={addButtonStyle}
            onClick={onAddFile}
          >
            <Stack direction="vertical" gap={1}>
              <FontAwesomeIcon icon={faPlus} size="3x" />
              <span>Add File</span>
            </Stack>
          </Button>
        </Stack>
      </div>
      <div className="w-auto d-inline-block mb-2">
        <Stack direction="vertical">
          <Button
            variant="outline-danger"
            style={addButtonStyle}
            onClick={onToggleRemove}
          >
            <Stack direction="vertical" gap={1}>
              <FontAwesomeIcon icon={faTrash} size="3x" />
              <span>Delete File</span>
            </Stack>
          </Button>
        </Stack>
      </div>
    </Row>
  );
};
